module.exports = __webpack_public_path__ + "static/media/Group14.9ad51af8.svg";